import { type Dispatch, type SetStateAction, useCallback, useState } from 'react';

export function useToggle(
    v: boolean = false,
): readonly [boolean, Dispatch<SetStateAction<boolean>>, () => void] {
    const [value, setValue] = useState(v);
    const toggle = useCallback(() => setValue(prev => !prev), []);
    return [value, setValue, toggle];
}
